const IP = 'IP';
const TIME_USED = 'Time Used';
const LAST_DATE = 'Last Date';

const historyColumns = [IP, TIME_USED, LAST_DATE];

export { historyColumns };
